import axios from "axios";

import variables from "@/global/variables";
import session from "@/global/session";

/*
 * Admin/test client for auction-admin.php. The admin secret is sent in the
 * X-Admin-Secret header (same posture as AuctionCloseModel).
 */

export interface BidHistoryEntry {
	bidNumber: number;
	amount: number;
	createdAt: string;
}

export interface SimulateBidResult {
	accepted: boolean;
	reason?: string | null;
	itemNumber: number;
	bidNumber: number;
	amount: number;
	currentBid?: number | null;
	minimumNextBid?: number | null;
	outbidTextSent?: boolean;
	outbidLeaderBidNumber?: number | null;
}

function headers(routeSecret?: string): { [key: string]: string } {
	const h: { [key: string]: string } = { "Content-Type": "application/json" };
	const token = session.token();
	if (token) h["X-Bidder-Token"] = token;
	if (routeSecret) h["X-Admin-Secret"] = routeSecret;
	return h;
}

function post(body: object, routeSecret?: string) {
	return axios.post(variables.apiEndpoint + "/auction-admin.php", body, { headers: headers(routeSecret) }).then((r) => r.data);
}

export default class AuctionAdminModel {
	static simulateBid(itemNumber: number, bidNumber: number, amount?: number | null, routeSecret?: string): Promise<SimulateBidResult> {
		return post({ action: "simulate_bid", itemNumber, bidNumber, amount: amount || undefined }, routeSecret);
	}

	static resetItem(itemNumber: number, routeSecret?: string): Promise<any> {
		return post({ action: "reset_item", itemNumber }, routeSecret);
	}

	static resetAll(routeSecret?: string): Promise<any> {
		return post({ action: "reset_all" }, routeSecret);
	}

	static setStatus(status: "open" | "closed", routeSecret?: string): Promise<any> {
		return post({ action: "set_status", status }, routeSecret);
	}

	static history(itemNumber: number, routeSecret?: string): Promise<BidHistoryEntry[]> {
		return axios
			.get(variables.apiEndpoint + "/bid-history.php", { params: { itemNumber }, headers: headers(routeSecret) })
			.then((r) => (r.data && r.data.bids ? r.data.bids : []));
	}
}
